import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const initialState = [];

export const queriesSlice = createSlice({
  name: 'queries',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    addQueryAnParentTable: (state, action) => {
      state.push(action.payload)
    },

    addQueryofTable: (state, action) => {
      let objecto = {
        tableOriginId: undefined,
        query: "",
        tableCreatedId: undefined
      }
      objecto.query = action.payload
      state.push(objecto)
    },
    addCreatedTableId: (state, action) => {
      state.map((item) => item.tableCreatedId == undefined ? item.tableCreatedId = action.payload : item.tableCreatedId)
    },
    resetQueries: (state) => initialState
  }
});

export const { addQueryAnParentTable, resetQueries, addCreatedTableId, addQueryofTable } = queriesSlice.actions;

export const queries_state = (state) => state.queries;

export default queriesSlice.reducer;
